"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wooCommerce = void 0;
const wooCommerce = () => {
    // on document click
    document.addEventListener('click', function (event) {
        let target = event.target;
        if (target.id === 'order-now') {
            event.preventDefault();
            let input = document.querySelector('[name="order-now"]');
            let form = document.querySelector('form.cart');
            input.value = "true";
            form.submit();
        }
        if (target.matches('[data-toggle="product-aside"]')) {
            event.preventDefault();
            const aside = document.querySelector('.single-product aside');
            aside.classList.toggle('is-open');
            if (aside.classList.contains('is-open')) {
                target.setAttribute('aria-expanded', 'true');
            }
            else {
                target.setAttribute('aria-expanded', 'false');
            }
        }
    });
};
exports.wooCommerce = wooCommerce;
